import { typeCheckAppModule } from "src/utils";
import { OutageDetail } from "./OutageDetail";

export const outageDetail = typeCheckAppModule({
    NAME: "subscriptions",
    Container: OutageDetail,
});
